export default __webpack_public_path__ + "static/media/hht2_ep1_speaking_04.81cdbbde.png";